var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc114(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "13.679mm",
    height: "9.8292mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 887.68 637.85",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2465265867392"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M618.45 173.41c0,-95.78 -77.64,-173.41 -173.41,-173.41 -95.78,0 -173.41,77.64 -173.41,173.41 0,95.78 77.64,173.41 173.41,173.41 95.78,0 173.41,-77.64 173.41,-173.41zm-151.78 -93.24l0 74.34 71.94 0 0 37.43 -71.94 0 0 73.66 -41.55 0 0 -73.83 -71.6 0 0 -37.26 71.6 0 0 -74.34 41.55 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M443.15 637.85c-189.56,-2.75 -360.6,-115.17 -438.36,-288.11l-4.79 -10.13 166.89 0 2.23 2.92c62.85,89.57 165.22,143.36 274.7,144.23 109.49,-0.79 211.89,-54.56 274.72,-144.23l2.23 -2.92 166.9 -0.01 -4.63 10.13c-78.06,173.44 -249.75,285.81 -439.89,288.08l-0.01 0.03zm-420.31 -283.81c77.5,162.35 240.48,266.78 420.31,269.38 179.83,-2.66 342.74,-107.16 420.29,-269.39l-137.33 0.01c-65.61,91.38 -170.94,146.12 -283.46,147.15 -112.36,-1.25 -217.58,-55.93 -283.15,-147.17l-136.67 0.02z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.382845 -0.923813 0.923813 0.382845 258.027 589.677)",
    width: 136.15,
    height: 14.42
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.92388 -0.382683 0.382683 0.92388 571.903 460.592)",
    width: 14.42,
    height: 136.15
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc114);
export default __webpack_public_path__ + "static/media/ic_1_14.3b3dd9d50bbda9f352a7c9a80c624a26.svg";
export { ForwardRef as ReactComponent };